// +----------------------------------------------------------------------
// | Desc:路径库(路径组合、接口请求、链接跳转等)
// +----------------------------------------------------------------------
import Vue from 'vue';

// +----------------------------------------------------------------------
// | Desc:跳转到页面
// +----------------------------------------------------------------------
// | Param:param page跳转的页面
// +----------------------------------------------------------------------
Vue.prototype.$go = function (page) {
    this.$router.push(page);
}

// +----------------------------------------------------------------------
// | Desc:跳转到上一页，如果没有上一页默认跳转到首页
// +----------------------------------------------------------------------
// | Param:url 如果没有上一页跳转位置 
// | Param:type 跳转方式，默认tabbar
// +----------------------------------------------------------------------
// | Reurn:void;
// +----------------------------------------------------------------------
Vue.prototype.$goBack = function (url, type) {
    // 检查是否可以安全地返回上一页
    if (this.$router && this.$route && this.$router.history.length > 1) {
        // 如果可以，就返回上一页
        this.$router.go(-1);
    } else {
        // 如果无法返回上一页，可以做一些处理，比如提示用户
        this.$msg('无法返回上一页，已经是第一页了');
    };
}


// +----------------------------------------------------------------------
// | Desc:请求接口封装防抖函数
// +----------------------------------------------------------------------
Vue.prototype.$debounce = function (func, wait, that) {
    return function (...args) {
        const context = this;
        clearTimeout(that.timeout);
        that.timeout = setTimeout(() => func.apply(context, args), wait);
    }
};


// +----------------------------------------------------------------------
// | Desc: 请求接口封装
// +----------------------------------------------------------------------

Vue.prototype.$httpsApi = function (https, callbackOK, callbackError) {
    // 当前 Vue 实例的引用
    let that = this;

    // 获取请求类型，默认为分页列表请求
    var type = https.type || "isPagelist";

    // 获取 API 接口方法
    var api = https.api || "";

    // 获取请求参数，默认为空对象
    var parameter = https.parameter || {};

    // 获取加载状态标识，默认为 undefined
    var isLoading = https.isLoading;

    // 获取错误提示信息，默认为空字符串
    var errorMsg = https.errorMsg || "";
    var successMsg = https.successMsg || "";

    // 根据请求类型设置默认的加载状态标识
    if (type == 'isPagelist') {
        // 清空已选中的行
        that.selectedRows = [];
        // 设置默认的加载状态标识
        isLoading = isLoading || "isLoadingStr";
    }

    if (type == 'isRow') {
        // 设置默认的加载状态标识
        isLoading = isLoading || "isLoadingPop";
    }

    // 根据加载状态标识显示加载状态
    if (isLoading == 'isLoadingStr') {
        that.loading = true;
    }

    if (isLoading == 'isLoadingPop') {
        that.$loading(true);
    }

    // 发起 API 请求
    api(parameter).then((res) => {
        // 根据加载状态标识隐藏加载状态
        if (isLoading == 'isLoadingStr') {
            that.loading = false;
        }

        if (isLoading == 'isLoadingPop') {
            that.$loading(false);
        }

        // 检查响应状态码
        if (res.code == 0) {
            // 如果请求成功
            if (type == 'isPagelist') {
                // 更新分页列表数据
                that.list = res.data;
                that.total = res.count;
            }

            if (type == 'isRow') {
                // 更新单行数据
                that.row = res.data;
            }

            if (!this.$isblank(successMsg)) {
                this.$msg(successMsg, 'success');
            };

            // 执行成功回调
            callbackOK && callbackOK(res);
        } else {
            // 如果请求失败
            if (this.$isblank(errorMsg)) {
                this.$msg(res.msg, 'error');
            } else {
                this.$msg(errorMsg, 'error');
            };
            // 执行失败回调
            callbackError && callbackError(res);
        }
    });
}
// +----------------------------------------------------------------------
// | Desc:路径拼接库
// +----------------------------------------------------------------------
Vue.prototype.$httpServerH5 = function (url) {
    var config = this.$configBase();
    if (this.$isblank(url)) {
        return "";
    }
    if (!url.includes("http")) {
        var url = config.serverH5 + url;
    }
    return url;
};

// +----------------------------------------------------------------------
// | Desc:路径拼接库
// +----------------------------------------------------------------------
Vue.prototype.$httpQiyebigscreen = function (url) {
    var config = this.$configBase();
    if (this.$isblank(url)) {
        return "";
    }
    if (!url.includes("http")) {
        var url = config.qiyebigscreenH5 + url;
    }
    return url;
};

// +----------------------------------------------------------------------
// | Desc:图片路径拼接库
// +----------------------------------------------------------------------
Vue.prototype.$httpImg = function (url, isface) {
    var config = this.$configBase();
    if (this.$isblank(url)) {
        if (isface == "isface") {
            return config.img + "/static/noface.png";
        };
        return config.img + "/static/noimg.png";
    };
    if (!url.includes('http')) {
        var url = config.img + url;
    };
    return url;
}


// +----------------------------------------------------------------------
// | Desc:获取url参数
// +----------------------------------------------------------------------
Vue.prototype.$getUrlParams = function (param) {
    const urlParams = new URLSearchParams(window.location.search);
    var res = urlParams.get(param);
    if (res) {
        return res;
    } else {
        return "";
    }
};
